import React from 'react';

import CircleIcon from '@mui/icons-material/Circle';
import { Box, Grid, Typography } from '@mui/material';

import { IBranding } from '../../../types/Branding';
import { primaryBlue } from '../../constants/colors';
import { IOrderStatus } from '../../type';
import { getWindowDimensions } from '../../utils/helpers';
import BackToDashboard from '../BackToDashboard';

interface IProps {
  orderStatus: IOrderStatus;
  isGuest: boolean;
  backClicked: () => void;
  status: string;
  branding: IBranding | null;
}

function OrderDetailsHeader(props: IProps) {
  const { orderStatus, isGuest, backClicked, status, branding } = props;
  const windowSize = getWindowDimensions().width;
  const left = windowSize > 400 ? 2.5 : 1;
  const isInProgress =
    status.toLowerCase().includes('open') &&
    !status.toLowerCase().includes('failed');
  const isBranding =
    branding?.Logo?.Path && branding?.Logo?.BaseUrl ? true : false;
  const brandPath = isBranding
    ? `${branding?.Logo?.BaseUrl}${branding?.Logo?.Path}`
    : '';

  return (
    <>
      <Grid
        container
        sx={{
          paddingLeft: left,
          paddingRight: windowSize > 400 ? 2.5 : 1.5,
          paddingTop: 1,
          paddingBottom: 1,
          backgroundColor: primaryBlue,
          alignItems: 'center',
          justifyContent: 'center',
        }}>
        <Grid item xs={4}>
          {!isGuest && (
            <BackToDashboard
              backClicked={backClicked}
              customStyling={{
                color: 'white',
                fontSize: windowSize > 400 ? 14 : 12,
              }}
            />
          )}
        </Grid>
        <Grid item xs={4}>
          {isBranding && (
            <Box style={{ display: 'flex', justifyContent: 'center' }}>
              <img
                style={{ width: 'auto', height: '30px' }}
                src={brandPath}
                alt={branding?.Logo?.AltText}
              />
            </Box>
          )}
        </Grid>
        <Grid item xs={4}>
          {(orderStatus.name == 'COMPLETE' || isInProgress) && (
            <Grid
              container
              sx={{
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                display: 'flex',
                color: 'white',
              }}>
              <Grid
                item
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}>
                <CircleIcon
                  color={orderStatus.color}
                  fontSize='small'
                  sx={{ marginRight: 2 }}
                />
                <Typography
                  variant='button'
                  fontSize={windowSize > 400 ? 14 : 12}>
                  {orderStatus.name}
                </Typography>
              </Grid>
            </Grid>
          )}
        </Grid>
      </Grid>
    </>
  );
}

export default OrderDetailsHeader;
